import * as Yup from 'yup';
import { IResetPasswordStore } from "./types";

export const RESET_PASSWORD_COOLDOWN = 60;

// Изначальные данные полей ввода в форме изменения пароля
export const INITIAL_RESET_PASSWORD_STORE: IResetPasswordStore = {
	isRequestSent: false,
	cooldownEnd: 0,
    emailInput: {
        value: '',
        type: 'email',
        isValid: true,
        errorMessage: ''
    },
}

const NEW_RESET_PASSWORD_SCHEMA = Yup.object({
  value: Yup.string()
    .required('Введите почту')
    .email('Введите корректный адрес электронной почты')
});

// Схема валидации формы изменения пароля
export const NEW_RESET_PASSWORD_VALIDATION_SCHEMA = Yup.object().shape({
    emailInput: NEW_RESET_PASSWORD_SCHEMA,
});
